import {Mapper} from '@s-ui/domain'

import {VehiclesMappersFactory} from '../../vehicles/Mappers/factory.js'
import SeoValueObjectsFactory from '../ValueObjects/factory.js'
import SeoMappersFactory from './factory.js'

export class FromRawsAIFaqsToFaqsListVOMapper extends Mapper {
  constructor({config, faqsInfoValueObjectFactory, faqStructuredDataSeoMapper, fromRawFaqToFaqListValueObjectMapper}) {
    super()
    this._config = config
    const hostDomain = config.get('HOST_DOMAIN')
    this._urlOrigin = `https://${hostDomain}`
    this._faqsInfoValueObjectFactory = faqsInfoValueObjectFactory
    this._faqStructuredDataSeoMapper = faqStructuredDataSeoMapper
    this._fromRawFaqToFaqListValueObjectMapper = fromRawFaqToFaqListValueObjectMapper
  }

  static create({config}) {
    return new FromRawsAIFaqsToFaqsListVOMapper({
      config,
      faqsInfoValueObjectFactory: SeoValueObjectsFactory.faqsInfoValueObject,
      faqStructuredDataSeoMapper: SeoMappersFactory.faqStructuredDataSeoMapper({
        config
      }),
      fromRawFaqToFaqListValueObjectMapper: VehiclesMappersFactory.fromRawFaqToFaqListValueObjectMapper({
        config
      })
    })
  }

  _getFaqSEO = ({faqs, path}) => {
    if (!faqs) return []
    const mainEntity = faqs.map(({question, answer}) => {
      return {
        acceptedAnswer: {
          '@type': 'Answer',
          text: answer
        },
        name: question,
        '@type': 'Question'
      }
    })

    const url = `${this._urlOrigin}${path}`
    const seoFaqDataStructure = {
      '@context': 'http://schema.org',
      '@id': url,
      '@type': 'FAQPage',
      description: '',
      name: url,
      url,
      mainEntity
    }

    return this._faqStructuredDataSeoMapper.map({
      seoFaqDataStructure
    })
  }

  map = ({faqs, path}) => {
    return this._faqsInfoValueObjectFactory({
      seoFaqs: this._getFaqSEO({faqs, path}),
      faqs: this._fromRawFaqToFaqListValueObjectMapper.map({
        faqs: faqs
          .map(({question, answer}) => {
            if (!question || !answer) return null
            return {name: question, acceptedAnswer: {text: answer}}
          })
          .filter(Boolean)
      })
    })
  }
}
